import { WorkspaceActions, WorkspaceSubjects } from '@/types/schema';

export const subjectLabelMap: Record<WorkspaceSubjects, string> = {
  [WorkspaceSubjects.Academy]: 'academy',
  [WorkspaceSubjects.Announcement]: 'announcement',
  [WorkspaceSubjects.Learner]: 'learner',
  [WorkspaceSubjects.Assignment]: 'assignment',
  [WorkspaceSubjects.Attendance]: 'attendance',
  [WorkspaceSubjects.Certificate]: 'certificate',
  [WorkspaceSubjects.Community]: 'community',
  [WorkspaceSubjects.ContentCollection]: 'collection',
  [WorkspaceSubjects.Event]: 'session',
  [WorkspaceSubjects.Group]: 'group',
  [WorkspaceSubjects.Homepage]: 'homepage',
  [WorkspaceSubjects.Members]: 'members',
  [WorkspaceSubjects.Post]: 'post',
  [WorkspaceSubjects.Resource]: 'content',
  [WorkspaceSubjects.Role]: 'staff role',
  [WorkspaceSubjects.Scorecard]: 'scorecard',
  [WorkspaceSubjects.Space]: 'space',
  [WorkspaceSubjects.Staff]: 'staff',
  [WorkspaceSubjects.Tag]: 'tag',
  [WorkspaceSubjects.User]: 'user',
  [WorkspaceSubjects.UserCollection]: 'group',
  [WorkspaceSubjects.Workspace]: 'workspace',
  [WorkspaceSubjects.Channel]: 'channel',
  [WorkspaceSubjects.Report]: 'report',
  [WorkspaceSubjects.SharedConnection]: 'shared connection',
  [WorkspaceSubjects.ContentSubworkspace]: 'content subworkspace',
  [WorkspaceSubjects.EventSubworkspace]: 'event subworkspace',
  [WorkspaceSubjects.Authentication]: 'authentication',
  [WorkspaceSubjects.OkrCycle]: 'cycle',
  [WorkspaceSubjects.Skill]: 'skill',
  [WorkspaceSubjects.SkillMatrix]: 'skill matrix',
  [WorkspaceSubjects.CompanyObjective]: 'company objective',
  [WorkspaceSubjects.DepartmentObjective]: 'department objective',
  [WorkspaceSubjects.EmailDigest]: 'email digest',
  [WorkspaceSubjects.IndividualObjective]: 'individual objective',
  [WorkspaceSubjects.Okr]: 'okr',
  [WorkspaceSubjects.TeamObjective]: 'team objective',
  [WorkspaceSubjects.Integration]: 'integrations',
  [WorkspaceSubjects.Billing]: 'billing',
  [WorkspaceSubjects.Subaccount]: 'subaccounts',
  [WorkspaceSubjects.ReviewCycle]: 'review cycle',
  [WorkspaceSubjects.Department]: 'department',
  [WorkspaceSubjects.File]: 'file',
  [WorkspaceSubjects.Category]: 'category',
  [WorkspaceSubjects.TagSubworkspace]: 'tag subworkspace',
  [WorkspaceSubjects.Recordings]: 'recordings',
  [WorkspaceSubjects.UserSurvey]: 'survey',
  [WorkspaceSubjects.AuditLog]: 'audit log',
  [WorkspaceSubjects.Journey]: 'journey',
  [WorkspaceSubjects.Metric]: 'metric',
  [WorkspaceSubjects.Gamification]: 'gamification',
};

export const actionLabelMap: Record<WorkspaceActions, string> = {
  [WorkspaceActions.Archive]: 'ARCHIVE',
  [WorkspaceActions.Create]: 'CREATE',
  [WorkspaceActions.Edit]: 'EDIT',
  [WorkspaceActions.Hide]: 'HIDE',
  [WorkspaceActions.Invite]: 'INVITE',
  [WorkspaceActions.List]: 'LIST',
  [WorkspaceActions.Manage]: 'MANAGE',
  [WorkspaceActions.Pin]: 'PIN',
  [WorkspaceActions.Publish]: 'PUBLISH',
  [WorkspaceActions.Read]: 'VIEW',
  [WorkspaceActions.Remove]: 'DELETE',
  [WorkspaceActions.Enroll]: 'ENROLL',
  [WorkspaceActions.Approve]: 'APPROVE',
  [WorkspaceActions.Reject]: 'REJECT',
  [WorkspaceActions.Send]: 'SEND',
  [WorkspaceActions.ShareContent]: 'SHARE',
  [WorkspaceActions.Masquerade]: 'MASQUERADE',
  [WorkspaceActions.Attach]: 'ATTACH',
  [WorkspaceActions.Checkin]: 'CHECKIN',
  [WorkspaceActions.Merge]: 'MERGE',
};
